import ActionableView from "common/ActionableView";
import BqnContext from "common/BqnContext";
import { toObjectLiteral } from "common/utils";
import { useContext, useEffect, useState } from "react";
import {
  useParams,
  useNavigate,
  createSearchParams,
  useSearchParams,
} from "react-router-dom";

export function RouteAdapter({ Component }) {
  const [jsReady, setJsReady] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const bqnContext = useContext(BqnContext);

  useEffect(() => {
    window.globalNavigate = navigateWithQueryParams;
    window.globalNavigateBack = navigateBack;
    window.globalNavigateBackJs = navigateBackJs;
    window.globalSearchParams = searchParams;

    checkJsReady();
  }, []);

  useEffect(() => {
    window.globalSearchParams = searchParams;
  }, [searchParams]);

  useEffect(() => {
    if(!jsReady){
      return;
    }

    const isLogged = window.login.isLogged();

    if(isLogged){
      bqnContext.loadOnce();
    }

    if (location.pathname !== "/viewLogin" && !isLogged) {
      return navigate({
        pathname: "/viewLogin",
        search: createSearchParams({
          url: location.pathname.slice(1),
        }).toString(),
      });
    } else if (location.pathname === "/" && location.hash === '' && isLogged) {
      return navigate("/viewDashboard");
    }

    if (!Component && params.view && (params.view === "viewLogin" || isLogged)) {
      const dpiFunctionality = window.functionality.isEnabled("dpi-per-user");
      window.views.toggle(params.view, {
        ...toObjectLiteral(searchParams),
        dpiEnabled: dpiFunctionality,
      });
    }else if(location.hash !== ''){
      location.href = location.href.replace('#', '');
    }
  }, [params.view, jsReady]);

  useEffect(() => {
    if(Component && jsReady){
      const isLogged = window.login.isLogged();

      if(isLogged){
        bqnContext.loadOnce();
      }
    }
  }, [Component, jsReady])

  function filterParams(input) {
    const output = {};
    for (const [key, value] of Object.entries(input)) {
      if (value !== undefined && value !== null && key !== "dpiEnabled") {
        output[key] = value;
      }
    }

    return output;
  }

  function navigateWithQueryParams(path, queryParams, options={}) {
    navigate({
      pathname: "/" + path,
      search: createSearchParams(
        queryParams ? filterParams(queryParams) : undefined
      ).toString(),
    }, options);
  }

  function navigateBack() {
    navigate(-1);
  }

  function navigateBackJs(element) {
    $(element).hide(250);
    navigate(-1);
  }

  function updateUI() {
    if(location.pathname === "/viewLogin"){
      $("#navigationBar").hide();
    }else{
      $("#navigationBar").show();
    }
    $("#sectContent").hide();
  }

  function checkJsReady(){
    if(window.login){
      setJsReady(true);
    }else{
      setTimeout(() => {
        checkJsReady();
      }, 1000)
    }
  }


  if (
    !jsReady ||
    !Component ||
    ((bqnContext.loginBqnId === undefined ||
      bqnContext.bqnId === undefined ||
      bqnContext.bqns === undefined) &&
      location.pathname !== "/viewLogin")
  ) {
    return null;
  }

  updateUI();

  const dpiEnabled = window.functionality.isEnabled("dpi-per-user");

  return (
    <ActionableView
      Component={Component}
      {...toObjectLiteral(searchParams)}
      dpiEnabled={dpiEnabled}
    />
  );
}
